import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { BrowserRouter } from 'react-router-dom';

import { RootLayout } from '~/components/RootLayout';
import { isEnvEnabled } from '~/lib/env';
import { AuthenticationProvider } from '~/modules/auth/components/AuthenticationProvider';
import { FeatureFlagProvider } from '~/modules/experiments/components/FeatureFlagProvider';
import { LocaleProvider } from '~/modules/navigation';
import { ContainerQueryClientProvider } from '~/modules/query-client/ContainerQueryClientProvider';

import { AuthRouter } from './authRouter';
import { I18nProvider } from './i18n';

export function App() {
  return (
    <I18nProvider>
      <ContainerQueryClientProvider>
        <BrowserRouter>
          <RootLayout>
            <LocaleProvider>
              <AuthenticationProvider>
                <FeatureFlagProvider>
                  <AuthRouter />
                </FeatureFlagProvider>
              </AuthenticationProvider>
            </LocaleProvider>
          </RootLayout>
        </BrowserRouter>
        {isEnvEnabled('VITE_REACT_QUERY_DEVTOOLS_ENABLED', false) ? (
          // https://tanstack.com/query/latest/docs/framework/react/devtools
          <ReactQueryDevtools initialIsOpen={false} />
        ) : null}
      </ContainerQueryClientProvider>
    </I18nProvider>
  );
}

App.displayName = 'App';
